module.exports = __webpack_public_path__ + "img/full7-min.e91861db.png";